import axios from '@/plugins/axios'

/**
 * Manually create campaign
 *
*/
const createCampaign = async (form) => {
  try {
    const response = await axios.post('admin/campaigns', form)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Manually end campaign
 */
const endCampaign = async (id) => {
  try {
    const response = await axios.post(`admin/campaigns/${id}/end`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get campaign
 */
const getCampaign = async (id) => {
  try {
    const response = await axios.get(`admin/campaigns/${id}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get campaigns
 */
const getCampaigns = async ({
  // eslint-disable-next-line camelcase
  advertiser_id = null,
  // eslint-disable-next-line camelcase
  amount_start = 0,
  // eslint-disable-next-line camelcase
  amount_end = 0,
  // eslint-disable-next-line camelcase
  ctr_start = 0,
  // eslint-disable-next-line camelcase
  ctr_end = 0,
  // eslint-disable-next-line camelcase
  end_date_end = null,
  // eslint-disable-next-line camelcase
  end_date_start = null,
  page = 1,
  platform = null,
  type = null,
  search = null,
  status = null,
  // eslint-disable-next-line camelcase
  start_date_end = null,
  // eslint-disable-next-line camelcase
  start_date_start = null,
  // eslint-disable-next-line camelcase
  watcher_is_alert = null,
  // eslint-disable-next-line camelcase
  watcher_status = null
}) => {
  try {
    const params = {
      page: page
    }
    if (search) params.search = search
    // eslint-disable-next-line camelcase
    if (advertiser_id) params.advertiser_id = advertiser_id
    // eslint-disable-next-line camelcase
    if (amount_start > 0) params.amount_start = parseInt(amount_start * 100)
    // eslint-disable-next-line camelcase
    if (amount_end > 0) params.amount_end = parseInt(amount_end * 100)
    // eslint-disable-next-line camelcase
    if (ctr_start > 0) params.ctr_start = ctr_start
    // eslint-disable-next-line camelcase
    if (ctr_end > 0) params.ctr_end = ctr_end
    // eslint-disable-next-line camelcase
    if (end_date_end) params.end_date_end = end_date_end
    // eslint-disable-next-line camelcase
    if (end_date_start) params.end_date_start = end_date_start
    if (status) params.status = status
    if (platform) params.platform = platform
    if (type) params.type = type
    // eslint-disable-next-line camelcase
    if (start_date_end) params.start_date_end = start_date_end
    // eslint-disable-next-line camelcase
    if (start_date_start) params.start_date_start = start_date_start
    // eslint-disable-next-line camelcase
    if (watcher_is_alert !== '') params.watcher_is_alert = watcher_is_alert
    // eslint-disable-next-line camelcase
    if (watcher_status) params.watcher_status = watcher_status

    const response = await axios.get('admin/campaigns', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get list of importable campaigns
 *
 * @param {*} param
 * @returns
 */
const getImportableCampaigns = async ({
  platform,
  partner,
  // eslint-disable-next-line camelcase
  advertiser_id,
  search
}) => {
  try {
    const params = {
      platform,
      partner,
      // eslint-disable-next-line camelcase
      advertiser_id,
      search
    }

    const response = await axios.get('admin/campaigns/import', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Import campaign
 *
 * @param {*} param0
 * @returns
 */
const importCampaign = async (form) => {
  try {
    const response = await axios.post('admin/campaigns/import', form)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Sync campaign
 */
const syncCampaign = async (id) => {
  try {
    const response = await axios.post(`admin/campaigns/${id}/sync`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Manually update campaign
 *
 */
const updateCampaign = async (id, form) => {
  try {
    form._method = 'PUT'
    const response = await axios.post(`admin/campaigns/${id}`, form)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Update retention
 *
 */
const updateRetention = async (id, retention) => {
  try {
    const response = await axios.post(`admin/campaigns/${id}/update-retention`, {
      _method: 'PUT',
      retention: retention
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Upsert native contextual campaign
 * @param campaignId
 * @param platformId
 * @param creatives
 * @returns {Promise<any>}
 */
const upsertNativeContextualPushCampaignOnPlatform = async ({
  campaignId,
  platformId,
  creatives
}) => {
  try {
    const response = await axios.post(`admin/campaigns/${campaignId}/upsert-platform`, {
      _method: 'PUT',
      platform_id: platformId,
      creatives: creatives
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Upsert youtube campaign
 * @param campaignId
 * @param platformId
 * @param creatives
 * @returns {Promise<any>}
 */
const upsertYoutubeCampaignOnPlatform = async ({
  campaignId,
  platformId,
  creatives
}) => {
  try {
    const response = await axios.post(`admin/campaigns/${campaignId}/upsert-platform`, {
      _method: 'PUT',
      platform_id: platformId
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  createCampaign,
  endCampaign,
  getCampaign,
  getCampaigns,
  getImportableCampaigns,
  syncCampaign,
  importCampaign,
  updateCampaign,
  updateRetention,
  upsertNativeContextualPushCampaignOnPlatform,
  upsertYoutubeCampaignOnPlatform
}
